import React from "react";
import Box from "./base/box";
import { lightTeal, blueGradient } from "./base/colors";

import Navigation from "./navigation";
import SecondaryNavigation from "./secondary-navigation";

import SecondaryNavLinks from "./secondary-nav-links";

import { useContentContext } from "../context/content-context";

const MobileNav = ({ handleISIClick, ISIScrollButton }) => {
  const { isHCP } = useContentContext();

  return (
    <Box
      height={[
        "calc(100vh - 104px)",
        "calc(100vh - 124px)",
        "calc(100vh - 124px)",
      ]}
      width="100%"
      background={isHCP ? blueGradient : lightTeal}
      position="absolute"
      zIndex={5}
      overflow="hidden"
      padding="28px 30px"
    >
      <Navigation variant="mobileNavigation" />
      <SecondaryNavigation
        handleISIClick={handleISIClick}
        ISIScrollButton={ISIScrollButton}
      >
        <SecondaryNavLinks handleISIClick={handleISIClick} />
      </SecondaryNavigation>
    </Box>
  );
};

export default MobileNav;
